























import Vue from 'vue'
import dynPlaceholder from '../dynPlaceholder.vue'

interface SelectValue {
  label: string,
  value: string | number
}

export default Vue.extend({
  name: 'UiSelectInput',
  components: {dynPlaceholder},
  props: {
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    selectList: {
      type: Array as () => SelectValue[],
      default: () => []
    },
    disabled: Boolean,
    error: Boolean,
    dynamicPlaceholderText: String
  },
  methods: {
    onInput (event: string | number) {
      this.$emit('input', event)
    }
  },
  computed: {
    currentValue: {
      get (): any {
        if (this.multiSelect && !this.value) {
          return [];
        }
        return this.value
      },
      set () {
      }
    },
    showDynPldr (): boolean {
      return !!this.currentValue || this.error
    }
  }
})
